import { Component, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { looksLikeEmail, NewsletterService } from 'src/app/shared/api/newsletter.service';
import { BRAND } from 'src/app/shared/brand';

@Component({
    selector: 'app-footer-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent implements OnDestroy{
    /// The brand, for the template (shared/brand.ts).
    readonly brand = BRAND;
    /// PrimeHat links no social profile yet (SocialLinksComponent.items is empty).
    readonly hasSocialLinks = false;

    emailControl = new FormControl('', Validators.required);
    calling:boolean;
    destroy$:Subject<void> = new Subject();
    invalidEmail:boolean;
    constructor(private newsletter:NewsletterService, private toastr:ToastrService) { }
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    submit()
    {
        if (this.calling) { return; }

        this.emailControl.markAsTouched();
        if (this.emailControl.hasError('required')) { this.invalidEmail = false; return; }

        this.invalidEmail = !looksLikeEmail(this.emailControl.value);
        if (this.invalidEmail) { return; }

        this.calling = true;
        this.newsletter.subscribe(this.emailControl.value).pipe(takeUntil(this.destroy$)).subscribe(result =>
        {
            const notice = this.newsletter.notice(result);
            if (notice.ok) {
                this.toastr.success(notice.text, notice.title, { timeOut: 7000 });
                this.emailControl.reset();
            }
            else {
                this.toastr.error(notice.text, notice.title, { timeOut: 5000 });
            }
            this.calling = false;
        });
    }
}
